import { Link } from "react-router-dom";
import { BlockchainContext } from "./context/BlockchainContext";
import { useContext } from "react";

export default function Navbar() {
  const { approve, connectWallet, currentAccount } =
    useContext(BlockchainContext);

  const path = window.location.pathname;
  return (
    <nav className="sidebar_container">
      <ul className="sidebar">
        <li>
          <Link className="sidebarText" to="/">
            {" "}
            Home
          </Link>
        </li>
        {/*
        <li>
          <Link className="sidebarText" to="/lockedstaking">
            {" "}
            Locked Staking
          </Link>
        </li>
        <li>
          <Link className="sidebarText" to="/tokenstake">
            {" "}
            Token Staking
          </Link>
        </li>{" "} */}
        <li>
          <Link className="sidebarText" to="/Mint">
            {" "}
            Mint
          </Link>
        </li>{" "}
        {/*
        <li>
          <Link className="sidebarText" to="/StakeNFT">
            {" "}
            Stake NFT
          </Link>
        </li>{" "}*/}
        <li className="sidebarText" onClick={connectWallet}>
          {" "}
          {!currentAccount
            ? "Connect Wallet"
            : `${currentAccount.slice(0, 5)}...${currentAccount.slice(
                currentAccount.length - 4
              )}`}{" "}
        </li>
      </ul>{" "}
    </nav>
  );
}
